import { render, staticRenderFns } from "./DraggableModulesItem.vue?vue&type=template&id=5c2f6990&scoped=true&"
import script from "./DraggableModulesItem.vue?vue&type=script&lang=js&"
export * from "./DraggableModulesItem.vue?vue&type=script&lang=js&"
import style0 from "./DraggableModulesItem.vue?vue&type=style&index=0&id=5c2f6990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2f6990",
  null
  
)

export default component.exports